import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import React from "react";
import { Link } from "gatsby";
import Img from "gatsby-image";
import Slider from "infinite-react-carousel";
import Layout from "../components/layout";
import SEO from "../components/seo";
import sponsorCroozer from "../images/sponsors/croozer.png";
import sponsorDge from "../images/sponsors/dge.png";
import sponsorDskl from "../images/sponsors/dskl.png";
import sponsorFuhrer from "../images/sponsors/fuhrer.png";
import sponsorSparda from "../images/sponsors/sparda-muenchen.png";
import chaplin from "../images/chaplin.png";
import women from "../images/women.png"; // @ts-ignore
import PageSectionHeading from "../components/common/page-section-heading";
import PageSectionContainer from "../components/common/page-section-container";
import SubscriptionRequestCircle from "../components/common/subscription-request-circle";
import AuthorNames from "../components/author-names";
import ArticleListItem from "../components/article-list-item";
import format from "date-fns/format/index";
import de from "date-fns/locale/de";
import { utcToZonedTime } from "date-fns-tz";
import SubscriptionBadge, { SubscriptionBadgeSize } from "../components/badge/subscription-badge";
import { useAnalytics } from "../hooks/use-ga";
function IndexPage(_ref) {
    var data = _ref.data, pageContext = _ref.pageContext;
    var podcast = pageContext.podcast;
    var edition = data.allDatoCmsEdition.edges[0].node;
    var spotlight = data.allDatoCmsSpotlight.nodes && data.allDatoCmsSpotlight.nodes.length > 0 ? data.allDatoCmsSpotlight.nodes[0] : undefined;
    var magazine = data.allDatoCmsMagazine.edges[0].node;
    var editionArticles = edition.sections && edition.sections.length > 0 ? edition.sections.flatMap(function (section) {
        return section.articles;
    }) : [];
    var getTopContent = function getTopContent() {
        var isEdition = new Date(edition.meta.firstPublishedAt) > new Date(spotlight.meta.firstPublishedAt);
        return {
            isEdition: isEdition,
            slug: isEdition ? edition.slug : "spotlight/" + spotlight.slug,
            editorialSlug: isEdition ? edition.editorial.slug : spotlight.briefing.slug,
            title: isEdition ? "Ausgabe " + edition.label : "Spotlight " + spotlight.label,
            editorialTitle: isEdition ? edition.editorial.title : spotlight.briefing.title,
            editorialAuthors: isEdition ? edition.editorial.authors : spotlight.briefing.authors,
            editorialImage: isEdition ? edition.editorial.image.fluid : spotlight.briefing.image.fluid,
            excerpt: isEdition ? edition.editorial.excerpt : spotlight.briefing.excerpt,
            articles: isEdition ? editionArticles : spotlight.articles,
            featuredArticles: isEdition ? edition.leadArticles : spotlight.featuredArticles,
            articleList: isEdition ? edition.articleList : spotlight.articleList,
            currentMagazineBgColor: isEdition ? "#DCEFFD" : "#ffdfdf",
            subscriptionCircleBgColor: isEdition ? "#0066ba" : "#005C16",
            editionMakroskop: data.datoCmsGfkEditionMakroskop
        };
    };
    var topContent = getTopContent();
    var _useAnalytics = useAnalytics(), trackSubNewsletter = _useAnalytics.trackSubNewsletter;
    return /*#__PURE__*/ React.createElement(Layout, {
        className: !topContent.isEdition ? "is-spotlight front-page" : ""
    }, /*#__PURE__*/ React.createElement(SEO, null), topContent.featuredArticles && /*#__PURE__*/ React.createElement(Slider, {
        autoplay: true,
        arrows: false,
        adaptiveHeight: true,
        dots: true,
        slidesToShow: 1,
        autoplaySpeed: 14000,
        className: "front-page-slider w-full"
    }, topContent.featuredArticles.map(function (article, index) {
        var articleImage = article.image && article.image.fluid ? article.image.fluid : undefined;
        var articleLink = topContent.isEdition ? "/" + topContent.slug + "/" + article.slug + "/" : "/" + topContent.slug + "/" + article.slug + "/";
        var smallTitle = topContent.title;
        return /*#__PURE__*/ React.createElement(PageSectionContainer, {
            className: "mb-8 text-white bg-makroOrange",
            key: index
        }, /*#__PURE__*/ React.createElement(Link, {
            to: articleLink,
            className: "flex flex-wrap relative"
        }, /*#__PURE__*/ React.createElement(SubscriptionBadge, {
            size: SubscriptionBadgeSize.BOX,
            articleId: article.id,
            visibility: article.visibility,
            isEdition: topContent.isEdition,
            whiteIfSmallerMd: true,
            containerClasses: "absolute top-0 right-0 z-20"
        }), /*#__PURE__*/ React.createElement("div", {
            className: "w-full md:w-1/2 lg:w-1/3 pr-4"
        }, /*#__PURE__*/ React.createElement(PageSectionHeading, {
            title: smallTitle,
            textColor: "white"
        }), /*#__PURE__*/ React.createElement("div", {
            className: "pl-4 lg:pl-8"
        }, /*#__PURE__*/ React.createElement("h2", {
            className: "text-2xl md:text-4xl lg:text-5xl my-3 break-words"
        }, article.title), /*#__PURE__*/ React.createElement(AuthorNames, {
            authors: article.authors,
            link: false
        }), /*#__PURE__*/ React.createElement("div", {
            className: "font-medium mt-5 pb-5 h0 normal-line-height text-lg",
            dangerouslySetInnerHTML: {
                __html: article.excerpt
            }
        }))), /*#__PURE__*/ React.createElement("div", {
            className: "w-full md:w-1/2 lg:w-2/3 mt-6 md:mt-0 md:pl-2"
        }, /*#__PURE__*/ React.createElement(Img, {
            fluid: articleImage
        }))));
    })), /*#__PURE__*/ React.createElement("div", {
        className: "grid md:grid-cols-3 md:auto-rows-fr articleList"
    }, topContent.articleList && topContent.articleList.map(function (article, index) {
        var articleImage = article.image && article.image.fluid ? article.image.fluid : undefined;
        var articleLink = topContent.isEdition ? "/" + topContent.slug + "/" + article.slug + "/" : "/" + topContent.slug + "/" + article.slug + "/";
        return /*#__PURE__*/ React.createElement(ArticleListItem, {
            key: index,
            index: index,
            authors: article.authors,
            authorLinks: false,
            excerpt: article.excerpt,
            to: articleLink,
            title: article.title,
            smallTitle: article.smallTitle,
            containerStyle: "pb-8 min-h-422px",
            className: "h-full pb-8",
            image: articleImage,
            frontPage: true,
            isEdition: topContent.isEdition,
            visibility: article.visibility,
            articleId: article.id
        });
    })), /*#__PURE__*/ React.createElement(PageSectionContainer, {
        className: "mb-8"
    }, /*#__PURE__*/ React.createElement(PageSectionHeading, {
        title: "MAKROSKOP NEWSLETTER"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "px-4 md:px-8 md:pb-2"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mt-2 text-makroOrange text-xl h0 font-bold lg:text-2xl"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "block lg:hidden"
    }, "Mit unserem Newsletter behalten Sie den", /*#__PURE__*/ React.createElement("br", null), "perfekten \xDCberblick \xFCber unsere", /*#__PURE__*/ React.createElement("br", null), "Ausgaben, komprimiert auf die", /*#__PURE__*/ React.createElement("br", null), "zentralen Thesen unserer Autoren \u2013", /*#__PURE__*/ React.createElement("br", null), "kostenlos und direkt", /*#__PURE__*/ React.createElement("br", null), "in Ihre Mailbox."), /*#__PURE__*/ React.createElement("div", {
        className: "hidden lg:block"
    }, "Mit unserem Newsletter behalten Sie den perfekten \xDCberblick \xFCber unsere Ausgaben,", /*#__PURE__*/ React.createElement("br", null), "komprimiert auf die zentralen Thesen unserer Autoren \u2013", /*#__PURE__*/ React.createElement("br", null), "kostenlos und direkt in Ihre Mailbox.")), /*#__PURE__*/ React.createElement(Link, {
        to: "/newsletter/",
        onClick: function onClick() {
            return trackSubNewsletter("newsletterHomepage");
        },
        className: "block h0 font-medium text-right text-3xl md:text-4xl lg:text-5xl"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "hover:text-makroOrange"
    }, "Jetzt Newsletter abonnieren!")))), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap"
    }, /*#__PURE__*/ React.createElement(Link, {
        to: "/guide/",
        className: "w-full mb-8 lg:mb-0 lg:pr-4 lg:w-1/3"
    }, /*#__PURE__*/ React.createElement(PageSectionContainer, {
        className: "bg-makroOrangeLight relative min-h-379px"
    }, /*#__PURE__*/ React.createElement(PageSectionHeading, {
        title: "GUIDE F\xDCR EINSTEIGER"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "h0 text-3xl mt-10 px-4 pb-6 md:px-8 text-makroOrange relative z-10"
    }, "Die zentralen Themen, Thesen und Irrt\xFCmer der Wirtschaftstheorien."), /*#__PURE__*/ React.createElement("img", {
        src: chaplin,
        alt: "Chaplin",
        className: "absolute right-0 bottom-0",
        style: {
            width: "200px"
        }
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "block w-full lg:pl-2 lg:w-2/3"
    }, /*#__PURE__*/ React.createElement(PageSectionContainer, {
        className: "bg-makroBlue mb-8"
    }, /*#__PURE__*/ React.createElement(PageSectionHeading, {
        title: "DAS MAGAZIN F\xDCR WIRTSCHAFTSPOLITIK",
        className: "text-white-important"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap"
    }, /*#__PURE__*/ React.createElement(Link, {
        to: "/ueber-uns/",
        className: "block h0 text-3xl w-full px-4 pb-6 md:text-4xl md:px-8 md:w-3/4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-makroOrange mt-10"
    }, "It's MAKROSKOP, stupid!"), /*#__PURE__*/ React.createElement("div", {
        className: "mt-4 break-words text-white"
    }, "Ein guter wirtschaftstheoretischer Baukasten ist elementar f\xFCr alle Fragen der Zeit."), /*#__PURE__*/ React.createElement("div", {
        className: "text-makroOrange text-right pb-8"
    }, "Wir haben ihn.")), /*#__PURE__*/ React.createElement("div", {
        className: "hidden pr-4 md:block md:w-1/4"
    }, /*#__PURE__*/ React.createElement("img", {
        src: women,
        alt: "It's MAKROSKOP, stupid!"
    })))))), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full mb-8 md:pl-4 relative "
    }, /*#__PURE__*/ React.createElement(PageSectionContainer, {
        className: "home-page-events text-white"
    }, /*#__PURE__*/ React.createElement(PageSectionHeading, {
        className: "mb-4",
        title: "VERANSTALTUNGEN"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "lg:px-8"
    }, data.allDatoCmsEvent.edges.filter(function (event) {
        var utcDate = new Date(event.node.time).toISOString();
        return new Date() <= new Date(utcDate);
    }).map(function (event, index) {
        var utcDate = new Date(event.node.time).toISOString();
        var zonedDate = utcToZonedTime(utcDate, "Europe/Berlin");
        return /*#__PURE__*/ React.createElement(Link, {
            to: "/veranstaltung/" + event.node.slug,
            className: "block mb-5 text-xl",
            key: index
        }, /*#__PURE__*/ React.createElement("strong", {
            className: "h0 block font-medium text-2xl mb-2"
        }, event.node.title), /*#__PURE__*/ React.createElement("div", {
            className: "text-base"
        }, format(zonedDate, "dd. MMMM yyyy,  HH:mm", {
            locale: de
        }), " ", "Uhr"), /*#__PURE__*/ React.createElement("div", {
            className: event.node.locationName ? "mt-1 text-base" : ""
        }, event.node.locationName), /*#__PURE__*/ React.createElement("div", {
            className: "mt-2"
        }, event.node.shortDescription));
    }))))), /*#__PURE__*/ React.createElement(PageSectionContainer, {
        className: "pb-8"
    }, /*#__PURE__*/ React.createElement(PageSectionHeading, {
        className: "mb-6",
        title: "MAKROSKOP WIRD UNTERST\xDCTZT VON:"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap justify-center mb-2"
    }, /*#__PURE__*/ React.createElement("a", {
        href: "https://www.sparda-m.de/",
        target: "_blank",
        rel: "noopener noreferrer",
        className: "flex w-1/3 md:w-1/6 px-4 mb-4 lg:px-8 md:mb-0"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col justify-center"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("img", {
        src: sponsorSparda,
        alt: "Sparda Bank M\xFCnchen",
        style: {
            filter: "grayscale(100%)"
        }
    })))), /*#__PURE__*/ React.createElement("a", {
        href: "https://dskl.de/",
        target: "_blank",
        rel: "noopener noreferrer",
        className: "flex w-1/3 md:w-1/6 px-4 mb-4 lg:px-8 md:mb-0"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col justify-center"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("img", {
        src: sponsorDskl,
        alt: "DSKL",
        style: {
            filter: "grayscale(100%)"
        }
    })))), /*#__PURE__*/ React.createElement("a", {
        href: "https://www.croozer.com/",
        target: "_blank",
        rel: "noopener noreferrer",
        className: "flex w-1/3 md:w-1/6 px-4 lg:px-8"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col justify-center"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("img", {
        src: sponsorCroozer,
        alt: "Croozer",
        style: {
            filter: "grayscale(100%)"
        }
    })))), /*#__PURE__*/ React.createElement("a", {
        href: "http://zehnbeispiele.com/",
        target: "_blank",
        rel: "noopener noreferrer",
        className: "flex w-1/3 md:w-1/6 px-4 lg:px-8"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col justify-center"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("img", {
        src: sponsorFuhrer,
        alt: "Fuhrer",
        style: {
            filter: "grayscale(100%)"
        }
    })))), /*#__PURE__*/ React.createElement("a", {
        href: "https://www.das-gruene-emissionshaus.de/",
        target: "_blank",
        rel: "noopener noreferrer",
        className: "flex w-1/3 md:w-1/6 px-4 lg:px-8"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col justify-center"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("img", {
        src: sponsorDge,
        alt: "Das Gr\xFCne Emissionshaus",
        style: {
            filter: "grayscale(100%)"
        }
    })))))), /*#__PURE__*/ React.createElement(PageSectionContainer, {
        className: "mb-8 geldscheine"
    }, /*#__PURE__*/ React.createElement(PageSectionHeading, {
        className: "mb-6",
        title: "EDITION MAKROSKOP \u2013 JETZT BESTELLEN"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap edition-makroskop-books"
    }, topContent.editionMakroskop.books.length > 0 && /*#__PURE__*/ React.createElement("div", {
        className: "w-full md:w-1/3"
    }, /*#__PURE__*/ React.createElement(Link, {
        to: "/edition-makroskop/"
    }, /*#__PURE__*/ React.createElement(Img, {
        fluid: topContent.editionMakroskop.books[0].image.fluid,
        className: "edition-makroskop-image"
    }))), topContent.editionMakroskop.books.length > 1 && /*#__PURE__*/ React.createElement("div", {
        className: "w-full md:w-1/3"
    }, /*#__PURE__*/ React.createElement(Link, {
        to: "/edition-makroskop/"
    }, /*#__PURE__*/ React.createElement(Img, {
        fluid: topContent.editionMakroskop.books[1].image.fluid,
        className: "edition-makroskop-image"
    }))), topContent.editionMakroskop.books.length > 2 && /*#__PURE__*/ React.createElement("div", {
        className: "w-full md:w-1/3"
    }, /*#__PURE__*/ React.createElement(Link, {
        to: "/edition-makroskop/"
    }, /*#__PURE__*/ React.createElement(Img, {
        fluid: topContent.editionMakroskop.books[2].image.fluid,
        className: "edition-makroskop-image"
    }))))), /*#__PURE__*/ React.createElement("div", {
        className: "pb-12 flex flex-wrap"
    }, /*#__PURE__*/ React.createElement("a", {
        href: "https://makroskop.eu/fur-eine-gemeinschaftliche-wirtschaft/",
        className: "block w-full md:w-2/3 pb-8"
    }, /*#__PURE__*/ React.createElement(PageSectionContainer, null, /*#__PURE__*/ React.createElement(PageSectionHeading, {
        className: "mb-4",
        title: "MAKROSKOP Markups"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "text-makroOrange text-3xl lg:text-4xl h0 mt-4 xl:mt-12 mb-6 px-8"
    }, "F\xFCr eine gemeinschaftliche Wirtschaft"), /*#__PURE__*/ React.createElement("div", {
        className: "h0 text-xl lg:text-3xl font-medium px-8"
    }, "Wir machen Wirtschaftsjournalismus nach dem Leitbild einer sozialen Demokratie. Unsere zentralen Analysen und Vorschl\xE4ge."))), /*#__PURE__*/ React.createElement(SubscriptionRequestCircle, {
        textColor: "white",
        backgroundColor: topContent.subscriptionCircleBgColor,
        isMagazineOverview: true
    })));
}
var query = "3406516680";
export default IndexPage;
